import firebase from 'firebase';
import "firebase/firestore"
const firebaseConfig = {
    apiKey: "AIzaSyAYWQoiJpW0xeCJTIUaOM5b0gMuv_VCgrk",
    authDomain: "avito-clone.firebaseapp.com",
    projectId: "avito-clone",
    storageBucket: "avito-clone.appspot.com",
    messagingSenderId: "22590145313",
    appId: "1:22590145313:web:3e263b964c4a633c2ef460"
  };

const firebaseApp =firebase.initializeApp(firebaseConfig);

const data = firebaseApp.firestore();
const auth = firebase.auth();
export {data,auth};